<div class="form" *appTaskingAppContext>
  <div class="form-date">{{ project?.createdAt | dateFormat:'date' }}</div>

  <h2 class="form-title">
    <app-icon
      class="form-heading-title-icon"
      name="project"
      [style.color]="project?.color"
    />
    {{ project?.title }}
  </h2>

  @if (project) {
    <app-shared-tags
      class="form-tags"
      [stitchItem]="project"
      [stateKey]="StateKey.tagsList"
    />

    <app-shared-knots
      class="form-knots"
      [stitchItem]="project"
      [stateKey]="StateKey.knotsList"
    />
  }

  <app-shared-signup-cta />

  <div class="form-details">
    <div class="form-details-row">
      <div class="form-details-row-title">Parent Project</div>
      <div class="form-details-row-input">{{ project?.parentId }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Description</div>
      <stch-item-description class="form-details-row-input" stchHighlightText [html]="project?.description" />
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">From Date</div>
      <div class="form-details-row-input">{{ project?.startDateTime }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">To Date</div>
      <div class="form-details-row-input">{{ project?.endDateTime }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Priority</div>
      <div class="form-details-row-input">{{ project?.priority }}</div>
    </div>

    <!--This section is hidden for V1-->
    @if (false) {
    <div class="form-details-row">
      <div class="form-details-row-title">Issue Key</div>
      <div class="form-details-row-input">{{ project?.issueKey }}</div>
    </div>
    }
  </div>
</div>
